export const AGREEMENT = [
    {
        title: "Purpose & Partnership",
        content: [
            "Mentor: As a mentor, I commit to offering guidance, encouragement, and constructive feedback, helping my mentee explore their goals and gain new perspectives.",
            "Mentee: As a mentee, I commit to bringing openness, curiosity, and a willingness to grow, actively participating in each session."
        ]
    },
    {
        title: "Show Up Wholehearty",
        content: [
            "Be Fully Present: We agree to arrive focused putting aside distractions to be fully present each session to meaningful.",
            "Honor Our Time Together: We'll respect the time we've set aside and communicate promptly if rescheduling, understanding that each session is an opportunity to grow."
        ]
    },
    {
        title: "Build Trust Through Authenticity",
        content: [
            "Keep it Confidential: What we discuss stays within our mentorship. We create a safe space where honesty is valued, and trust can grow.",
            "Encourage Openness: We commit to being authentic, sharing ideas, challenges, and questions, creating an environment where each of us feels comfortable being ourselves."
        ]
    },
    {
        title: "Embrace Curiosity & Exploration",
        content: [
            "Keep an Open Mind: We approach each session with a willingness to explore new ideas and learn actively, knowing that fresh perspectives can lead to surprising insights.",
            "Be Yourself: We promise to bring our unique experiences, strengths, and ideas to each conversation, knowing that authenticity drives meaningful connection."
        ]
    },
    {
        title: "Midpoint Reflection",
        content: [
            "Reflect on progress: At the halfway mark, we'll take time to reflect on our progress. We'll discuss what's going well, areas to improve, and any adjustments that will help us make the most of the remainder of our time together."
        ]
    },
    {
        title: "End on a High Note",
        content: [
            "Throughout this journey, we aim to inspire each other and gain insights that last.",
            "We're committed to closing our time together with a sense of accomplishment and clear next steps.",
            "Every mentorship ends, but the impact can last a lifetime."
        ]
    }
]